/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { FC, ComponentType } from 'react';
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { Store } from 'redux';
import type { ReactReduxContextInstance } from 'react-redux--next/es/components/Context';
import type { WithIntlProps } from '@atlassian/jira-intl';
import { connect, type ConnectedComponent } from '@atlassian/jira-react-redux/src/index.tsx';
import { getFilterName, getOnCancel, isDataRetrieved } from '../state/selectors.tsx';
import type { State } from '../state/types.tsx';
import Content from './content/index.tsx';
import Footer from './footer/index.tsx';
import DeleteFiltersModal, { type Props } from './view.tsx';

const mapStateToProps = (state: State) => ({
	Content,
	Footer,
	name: getFilterName(state),
	onCancel: getOnCancel(state),
	isOpen: isDataRetrieved(state),
});

const DeleteFiltersModalView: ConnectedComponent<
	FC<WithIntlProps<Props>> & {
		WrappedComponent: ComponentType<Props>;
	},
	{
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		forwardedRef?: React.Ref<any> | undefined;
		context?: ReactReduxContextInstance | undefined;
		store?: Store | undefined;
	}
> = connect(mapStateToProps, {})(DeleteFiltersModal);
export default DeleteFiltersModalView;
